// extracted by mini-css-extract-plugin
export var arrow = "LanguageSwitcher-module--arrow--YeI+x";
export var container = "LanguageSwitcher-module--container--JeFyl";
export var flippedArrow = "LanguageSwitcher-module--flippedArrow--4EvQu";
export var icon = "LanguageSwitcher-module--icon--MtACr";
export var list = "LanguageSwitcher-module--list--Tfrvc";
export var listItem = "LanguageSwitcher-module--listItem--mb8xf";
export var listWrapper = "LanguageSwitcher-module--listWrapper--On3Ku";
export var selectedValue = "LanguageSwitcher-module--selectedValue--sGa7b";
export var visibleListWrapper = "LanguageSwitcher-module--visibleListWrapper--n+fRW";